import React, { useState } from "react";
import TrackLimoLogo from "../../assets/tracklimo-logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/fontawesome-free-solid";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/footer/Footer";
import { setError } from "../../redux/auth/auth-slice";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Bg from "../../assets/bg.jpg";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // selectors
  const { errmsg, isLoggedin } = useSelector((state) => state.auth);

  // states
  const [loginInputField, setloginInputField] = useState({
    companyid: "",
    password: "",
    username: "",
  });

  const [isVisible, setisVisible] = useState(false);
  const [isLoginDetailCheck, setisLoginDetailCheck] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({
      type: "AUTH_LOGIN",
      payload: {
        body: {
          companyid: loginInputField.companyid,
          username: loginInputField.username,
          password: loginInputField.password,
        },
        navigate,
      },
    });
  };

  return (
    <div className="relative">
      <div className="h-screen w-screen absolute">
        <div className="bg-black opacity-90 absolute w-full h-full"></div>
        <img src={Bg} alt="" className="h-full w-full bg-cover bg-center" />
      </div>

      <div className="space-y-5 sm:space-y-16 xl:space-y-5 relative px-2">
        <Link to="/">
          <div className="flex space-x-2 justify-start mx-5 xs:mx-14 sm:mx-20 md:mx-20 lg:mx-10">
            <img
              src={TrackLimoLogo}
              alt="Tracklimo Logo"
              className="w-48 h-32 sm:w-52 sm:h-24 md:w-60 md:h-32"
            />
          </div>
        </Link>

        {/* <div className="flex justify-center space-x-10 sm:justify-end md:justify-center lg:justify-end mx-5 sm:mx-0 md:mx-0 lg:mx-20 xl:mx-40 2xl:mx-60"> */}
        <div className="flex justify-center lg:space-x-10 sm:justify-center md:justify-center lg:justify-between mx-5 sm:mx-0 md:mx-0 lg:mx-10 xl:mx-24 2xl:mx-52">
          <div className="hidden lg:block mt-5">
            <div className="space-y-3">
              <h2 className="text-4xl text-slate-400 font-thin">Hello,</h2>
              <h3 className="text-6xl text-white font-medium">Welcome Back!</h3>
              <h3 className="w-[600px] lg:w-[460px] text-lg lg:text-base text-white font-thin pt-10 text-justify">
                
              </h3>
            </div>
          </div>
          <div className="relative">
            <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#190061] to-[#0A1B30] absolute -top-10 sm:-top-20 -left-20 md:-top-14 md:-left-32 lg:-left-16 xl:-left-32"></div>
            <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#041248] to-[#0A1B30] absolute -right-6 -bottom-10 sm:-bottom-16 sm:-right-6 md:-bottom-12 md:-right-16 lg:-right-6 lg:-bottom-6 xl:-right-16 xl:-bottom-12"></div>
            <div
              className={`backdrop-blur-md ${
                errmsg
                  ? " border-red-900 loginAlertAnimation"
                  : "bg-slate-800/5"
              }    border border-white/30 w-full sm:w-full md:w-full lg:w-[420px] xl:w-[480px] 2xl:w-[480px] rounded-2xl pt-5 sm:pt-10 pb-6 shadow-[rgba(0,0,15,0.5)_0px_5px_4px_10px] `}
            >
              <div className="text-3xl sm:text-4xl px-6 sm:px-10 text-left text-gray-200 font-semibold">
                <h2>Log In</h2>
                <div className="text-base font-normal mt-1">
                  Just some details to get you in!
                </div>
              </div>

              <div className="px-6 sm:px-10 pt-7 space-y-3.5 h-96">
                <InputField
                  // label="Company ID"
                  type="text"
                  placeholder="Company ID"
                  onChange={(e) => {
                    dispatch(
                      setError({
                        errmsg: "",
                      })
                    );
                    setloginInputField({
                      ...loginInputField,
                      companyid: e.target.value,
                    });
                  }}
                />
                <InputField
                  // label="Username"
                  type="text"
                  placeholder="Username"
                  onChange={(e) => {
                    dispatch(
                      setError({
                        errmsg: "",
                      })
                    );
                    setloginInputField({
                      ...loginInputField,
                      username: e.target.value,
                    });
                  }}
                />
                <div className="relative space-y-0.25">
                  <div className="text-white absolute right-3 top-2">
                    {/* <div className="text-lg text-gray-200 font-semibold">
                    Password
                  </div> */}
                    <div
                      className="cursor-pointer text-slate-500"
                      onClick={() => {
                        setisVisible(!isVisible);
                      }}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEye} />
                      ) : (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      )}
                    </div>
                  </div>
                  <input
                    onChange={(e) => {
                      dispatch(
                        setError({
                          errmsg: "",
                        })
                      );
                      setloginInputField({
                        ...loginInputField,
                        password: e.target.value,
                      });
                    }}
                    type={`${isVisible ? "text" : "password"}`}
                    placeholder="Password"
                    className="bg-transparent border rounded-md px-2 py-2.5 w-full target:bg-transparent focus:bg-transparent focus:outline-none focus:border-blue-600 text-gray-400 text-sm font-normal"
                  />
                </div>
                {/* <div className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    className="bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600"
                  ></input>
                  <h2 className="text-gray-400 text-sm">Remember Me</h2>
                </div> */}
                <div className="flex space-x-3">
                  <input
                    type="checkbox"
                    className=" bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600"
                    onClick={(e) => {
                      setisLoginDetailCheck(e.target.checked);
                    }}
                  ></input>
                  <h2 className="text-gray-400 text-sm">
                    I have read and agreed to the{" "}
                    <Link
                      to="/termsConditions"
                      className="font-medium text-gray-300 underline hover:no-underline"
                    >
                      Terms & Conditions
                    </Link>{" "}
                    &nbsp; & &nbsp;
                    <Link
                      to="/privacyPolicy"
                      className="font-medium text-gray-300 underline hover:no-underline"
                    >
                      Privacy policy
                    </Link>
                  </h2>
                </div>
                <div className="space-y-2">
                  {!isLoggedin ? (
                    <button
                      onClick={
                        isLoginDetailCheck === true 
                        ? handleSubmit 
                        : undefined
                      }
                      className={
                        isLoginDetailCheck === true 
                        ? `w-full flex justify-center cursor-pointer bg-gradient-to-r py-2.5 from-[#2f4def] to-[#0110a6] text-2xl font-medium rounded-md text-white`
                        : `w-full flex justify-center bg-gradient-to-r from-[#2f4def] to-[#0110a6] py-2.5 text-2xl font-medium rounded-md text-white cursor-not-allowed`
                      }
                    >
                      Login
                    </button>
                  ) : (
                    <div className="w-full flex justify-center cursor-pointer bg-gradient-to-r py-2.5 from-[#2f4def] to-[#0110a6] hover:bg-gradient-to-r text-lg font-medium rounded-md text-white">
                      <div class="flex items-center justify-center">
                        <div
                          class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                          role="status"
                        >
                          <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                            Loading...
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="text-center">
                    <Link
                      to="/forgotpassword"
                      className="cursor-pointer hover:underline text-lg text-slate-50"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                </div>
              </div>
              <h2 className="text-slate-300 text-center text-sm mt-5 sm:mt-10 font-light">
                &copy; Copyright 2024. Tracklimo Pvt Ltd. All rights reserved
              </h2>
                         
            </div>
          </div>
        </div>
        {/* <div className="px-10"><Footer /></div> */}
      </div>
    </div>
  );
};

export default LoginPage;

const InputField = ({ label, type, onChange, placeholder }) => {
  return (
    <>
      <div className="space-y-0.25">
        <div className="text-sm text-gray-200 font-semibold ">{label}</div>
        <input
          onChange={onChange}
          type={type}
          placeholder={placeholder}
          className="bg-transparent border rounded-md w-full px-2 py-2.5 target:bg-transparent focus:outline-none focus:border-blue-600 text-gray-400 text-sm font-normal"
        />
      </div>
    </>
  );
};
